import { render, staticRenderFns } from "./ChangePrice.vue?vue&type=template&id=de6165ac&scoped=true"
import script from "./ChangePrice.vue?vue&type=script&lang=js"
export * from "./ChangePrice.vue?vue&type=script&lang=js"
import style0 from "./ChangePrice.vue?vue&type=style&index=0&id=de6165ac&prod&lang=scss&scoped=true"
import style1 from "./ChangePrice.vue?vue&type=style&index=1&id=de6165ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6165ac",
  null
  
)

export default component.exports